import { render, staticRenderFns } from "./BenefitPreview.vue?vue&type=template&id=0778a192&"
import script from "./BenefitPreview.vue?vue&type=script&lang=js&"
export * from "./BenefitPreview.vue?vue&type=script&lang=js&"
import style0 from "./BenefitPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports